import { usePermissionsHook } from "./usePermissionsHook";
import { hasGroup, useUserGroupNames } from "./useUserGroupNames";

export const SIZER_VISIBILITY_GROUP = "Sizer Visibility";

/**
 * Who may see the **Sizers** section (header dropdown + `/sizers/*` routes).
 *
 * **Super admins and admins first** — allowed without consulting the group, no
 * fetch, no loading state. (`isAdmin` already includes super admins.) Admins
 * had the sizers under Admin before they moved out, so they keep them.
 *
 * Everyone else: membership in the org group named "Sizer Visibility" (matched
 * case-insensitively by NAME — renaming the group revokes access). Who gets the
 * sizers is a roster decision made on Users → Groups, so no emails live here.
 *
 * The backend doesn't need this gate: every sizer endpoint
 * (`/pricing/scenario/*`, `/pricing/scenarios*`, `/correspondents/list`) is
 * open to any signed-in user, and `GET /pricing/scenarios` already scopes a
 * non-admin to their own scenarios. This is a visibility gate, not security.
 *
 * Fails CLOSED while the lookup is in flight or errored.
 */
export const useCanSeeSizers = () => {
  const { isAdmin } = usePermissionsHook();
  const { names, loading } = useUserGroupNames({ skip: isAdmin });

  if (isAdmin) return { allowed: true, loading: false };

  return { allowed: hasGroup(names, SIZER_VISIBILITY_GROUP), loading };
};

export default useCanSeeSizers;
